import { useEffect, useRef, useState } from "react";
import css from "./ShortcutCommnet.module.scss";
import { listenDb, listenDbV2, offListenDbV2, writeDb } from "@/js/firebase";
import { getSympoUserInfo, getUrlParam, splitUserInfo } from "@/js/functions";
import { useLiveStore } from "@/template/live/_store";
import LikeAnimWrapper from "@/comp/LikeAnimWrapper";
import "swiper/css";
import "./swiper.scss";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { Button, Stack } from "@mui/material";
import { motion } from "framer-motion";

const ShortcutCommnet = () => {
  const { activeSession } = useLiveStore();
  const [tickerSettings, settickerSettings] = useState();
  const [autoSlideEnabled, setautoSlideEnabled] = useState(false);
  const [displaySlides, setdisplaySlides] = useState();
  const [animationInfo, setanimationInfo] = useState<
    | {
        shortcutIndex: number;
        unix: number;
      }
    | {}
  >({});
  const swiperRef = useRef(null);
  const swiperInstanceRef = useRef(null);
  const initAnimRef = useRef(false);

  //tickerSettingsをリッスン
  useEffect(() => {
    listenDb(`${getUrlParam(0)}/ticker/${getUrlParam(1)}`, (v) => {
      settickerSettings(v);
    });

    return () => {};
  }, []);

  useEffect(() => {
    if (!activeSession?.id) return;

    const path = `${getUrlParam(0)}/comment_ticker/${getUrlParam(1)}/${
      activeSession.id
    }`;
    const listener = (data) => {
      const val = data.val();
      if (val?.shortcutIndex !== undefined && initAnimRef.current) {
        setanimationInfo({
          shortcutIndex: val.shortcutIndex,
          unix: val.unix,
        });
      } else {
        initAnimRef.current = true;
      }
    };

    if (tickerSettings?.displayShortcutComment) {
      listenDbV2(path, listener, 1, "child_added");
    }

    return () => {
      offListenDbV2(path, listener);
    };
  }, [tickerSettings, activeSession]);

  // widthがはみ出したらスクロール
  useEffect(() => {
    if (!swiperInstanceRef.current || !tickerSettings?.displayShortcutComment)
      return;

    const displayComments = tickerSettings?.shortcutComments.map(
      (item, index) => {
        return {
          ...item,
          shortcutIndex: index,
        };
      }
    );

    if (!autoSlideEnabled) {
      setdisplaySlides(displayComments);
    } else {
      setdisplaySlides((prev) => [...displayComments, ...displayComments]);
      swiperInstanceRef.current.update();
      swiperInstanceRef.current.autoplay.start();
    }
  }, [autoSlideEnabled, tickerSettings]);

  useEffect(() => {
    if (
      autoSlideEnabled &&
      displaySlides?.length > tickerSettings?.shortcutComments?.length
    ) {
      swiperInstanceRef.current.autoplay.paused = false;
      swiperInstanceRef.current.autoplay.start();
    }
  }, [autoSlideEnabled, displaySlides, tickerSettings]);

  const checkAutoPlay = () => {
    const originalSlidesLength = tickerSettings?.shortcutComments?.length;
    let allSlidesWidth = 0;
    swiperInstanceRef.current.slidesSizesGrid.forEach((slide, index) => {
      if (index < originalSlidesLength) {
        const gap = index === 0 ? 0 : 12;
        allSlidesWidth += slide + gap;
      }
    });

    setautoSlideEnabled(allSlidesWidth >= swiperRef?.current?.swiper.width);
  };

  const sendComment = (comment, index) => {
    const commentId = Date.now();
    const userInfoStr = getSympoUserInfo(getUrlParam(0));
    const userInfo = splitUserInfo(userInfoStr);

    const body = {
      approval: 1,
      good: 0,
      id: commentId,
      meetingId: getUrlParam(1),
      name: userInfo[1],
      position: userInfo[2],
      private: 0,
      sentence: comment,
      session: activeSession.id,
      symposiumId: getUrlParam(0),
      unix: commentId,
      userId: userInfo[0],
      type: "shortcut",
      shortcutIndex: index,
    };

    writeDb(
      `${getUrlParam(0)}/comment_ticker/${getUrlParam(1)}/${activeSession.id}/${
        body.id
      }`,
      body
    );
  };

  return (
    <div className={`${css["comp"]}`}>
      {tickerSettings?.displayShortcutComment && (
        <Stack
          spacing={1}
          sx={{
            backgroundColor: "#eaeaea",
            mt: "4px",
            py: 1,
            // px: autoSlideEnabled ? 0 : 1, // 自動スクロールする時はpaddingを0にする
            px: 1,
          }}
        >
          <Swiper
            ref={swiperRef}
            autoplay={{
              delay: 0, // 途切れなくループ
              // reverseDirection: true, // 逆方向有効化
              disableOnInteraction: false,
            }}
            // initialSlide={0}
            loop={autoSlideEnabled} // ループ有効
            modules={[Autoplay]}
            slidesPerView={"auto"} // 一度に表示する枚数
            speed={5000} // ループの時間
            spaceBetween={12}
            centeredSlides={false}
            onResize={(swiper) => {
              checkAutoPlay();
            }}
            onSwiper={(swiper) => {
              swiperInstanceRef.current = swiper;
            }}
          >
            {displaySlides?.map((item, index) => {
              return (
                <SwiperSlide
                  key={`${item.label}-${index}`}
                  className={`${css["slide"]}`}
                >
                  <ShortcutCommentItem
                    item={item}
                    onClick={() => {
                      sendComment(item.label, item.shortcutIndex);
                    }}
                    animation={
                      animationInfo?.shortcutIndex === item.shortcutIndex
                    }
                    animUnix={
                      animationInfo?.shortcutIndex === item.shortcutIndex
                        ? animationInfo?.unix
                        : null
                    }
                  />
                </SwiperSlide>
              );
            })}
          </Swiper>
        </Stack>
      )}
    </div>
  );
};

const ShortcutCommentItem = ({ item, onClick, animation, animUnix }) => {
  const [clickUnix, setclickUnix] = useState(null);
  const swiper = useSwiper();
  const distanceRatio = useRef(null);
  const startTimer = useRef(null);
  const duration = useRef(null);

  // 以下URLの処理を改変
  // stopAutoplay内でstartAutoplayを呼び出すように変更
  // https://github.com/nolimits4web/swiper/issues/6481#issuecomment-1933677387
  const stopAutoplay = () => {
    if (startTimer.current) clearTimeout(startTimer.current);

    // Stop slide at current translate.
    swiper.setTranslate(swiper.getTranslate());

    // Calculating the distance between current slide and next slide.
    // 0.3 is equal to 30% distance to the next slide.
    distanceRatio.current = Math.abs(
      (swiper.width * swiper.activeIndex + swiper.getTranslate()) / swiper.width
    );

    // The duration that playing to the next slide
    duration.current = swiper.params.speed! * distanceRatio.current;

    swiper.autoplay.stop();

    startTimer.current = setTimeout(() => {
      startAutoplay();
    }, 3000);
  };

  const startAutoplay = (delay = duration.current) => {
    // console.log("startAutoplay", {
    //   activeIndex: swiper.activeIndex,
    //   getTranslate: swiper.getTranslate(),
    //   width: swiper.width,
    // });

    const distance = swiper.width * swiper.activeIndex + swiper.getTranslate();

    // Avoid distance that is exactly 0
    duration.current = distance !== 0 ? duration.current : 0;

    swiper.slideTo(swiper.activeIndex, swiper.params.speed);
    swiper.autoplay.start();
  };

  return (
    <LikeAnimWrapper
      animFlag={clickUnix || animation ? animUnix : false} // 他人のクリックに反応するためanimationのpropsも監視し、連続でアニメーションさせるためにunixも監視
    >
      <motion.div
        key={`${item.label}-${animUnix}`}
        initial={{ scale: 1 }}
        animate={animation ? { scale: [1, 1.2, 1] } : { scale: 1 }}
        transition={{ duration: 0.2, ease: "easeInOut" }}
      >
        <Button
          key={item.label}
          variant="contained"
          size="small"
          onClick={() => {
            setclickUnix(Date.now());
            stopAutoplay();
            onClick();
          }}
          sx={{
            width: "100%",
            fontSize: 14,
            fontWeight: "bold",
            minWidth: 110,
            px: "4px",
            textTransform: "none",
            backgroundColor: item.btnColor,
            "&:hover": {
              backgroundColor: item.btnColor,
            },
            "&:active": {
              backgroundColor: item.btnColor,
            },
          }}
        >
          {item.label}
        </Button>
      </motion.div>
    </LikeAnimWrapper>
  );
};

export default ShortcutCommnet;

// 奇数偶数に分ける
// function separateOddEven(array) {
//   let oddArray = [];
//   let evenArray = [];

//   for (let i = 0; i < array.length; i++) {
//     if (i % 2 === 0) {
//       evenArray.push(array[i]);
//     } else {
//       oddArray.push(array[i]);
//     }
//   }

//   return {
//     odd: oddArray,
//     even: evenArray,
//   };
// }
